import { useQuery } from '@tanstack/react-query';
import { getPostedInvoices } from '../Services/InvoiceService';

const useGetPostedInvoices = (params, options) =>
    useQuery({
        queryKey: ['getPostedInvoices', params],
        queryFn: () => getPostedInvoices(params),
        keepPreviousData: true,
        ...options,
    });

export default useGetPostedInvoices;
